/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {searchTimeOffChangeProposals} from '../api'

export const useMutationSearchTimeOffChangeProposals = createReactQueryMutationHook('searchTimeOffChangeProposals', searchTimeOffChangeProposals)
